export default __webpack_public_path__ + "static/media/hide.6149def3.svg";